import React from "react";

// styles
import {
    AdminDashboardContainer
} from "./AdminDashboard.styles.js";

// components
import ChecklistUploaderWidget from "./components/checklist-uploader-widget/ChecklistUploaderWidget.js";
import ReferralCodeUploaderWidget from "./components/referral-code-uploader-widget/ReferralCodeUploaderWidget.js";
import PromoStatsWidget from "./components/promo-stats-widget/PromoStatsWidget.js";

export default function AdminDashboard() {
    return (
        <AdminDashboardContainer>
            <PromoStatsWidget />
            <ChecklistUploaderWidget />
            <ReferralCodeUploaderWidget />
        </AdminDashboardContainer>
    );
}